import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Module } from 'app/library/module/models/module.model';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchGradingSchemes, FetchGradingSchemesFailure, FetchGradingSchemesSuccess } from '../actions';
import { FetchGradingSchemeByModuleIdFailure } from '../actions/fetch-grading-scheme-by-module-id-failure.action';
import { FetchGradingSchemeByModuleIdSuccess } from '../actions/fetch-grading-scheme-by-module-id-success.action';
import { FetchGradingSchemeByModuleId } from '../actions/fetch-grading-scheme-by-module-id.action';
import { SetGradingSchemeToModuleFailure } from '../actions/set-grading-scheme-to-module-failure.action';
import { SetGradingSchemeToModuleSuccess } from '../actions/set-grading-scheme-to-module-success.action';
import { SetGradingSchemeToModule } from '../actions/set-grading-scheme-to-module.action';
import { UnsetGradingSchemeFromModuleFailure } from '../actions/unset-grading-scheme-from-module-failure.action';
import { UnsetGradingSchemeFromModuleSuccess } from '../actions/unset-grading-scheme-from-module-success.action';
import { UnsetGradingSchemeFromModule } from '../actions/unset-grading-scheme-from-module.action';
import { GradingScheme } from '../models/grading-scheme.model';
import { GradingSchemeState } from '../models/grading-scheme.state';

@Injectable()
export class GradingSchemeService {
    @Select(GradingSchemeState.getEntities)
    allGradingScheme$: Observable<GradingScheme[]>;

    @Select(GradingSchemeState.getEntity)
    currentGradingScheme$: Observable<GradingScheme>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getAllGradingSchemes(): GradingScheme[] {
        return this._store.selectSnapshot(GradingSchemeState.getEntities);
    }

    getCurrentGradingScheme(): GradingScheme {
        return this._store.selectSnapshot(GradingSchemeState.getEntity);
    }

    async isModuleGraded(currentModule: Module): Promise<boolean> {
        let toReturn: boolean = false;
        const gradingScheme = this.getCurrentGradingScheme();

        if (gradingScheme?.id === currentModule.gradingSchemeId) {
            toReturn = true;
        } else {
            toReturn = false;
        }

        return toReturn;
    }

    async fetchGradingSchemes(): Promise<boolean> {
        this._store.dispatch(new FetchGradingSchemes());

        return await this._actionHelper.race(FetchGradingSchemesSuccess, FetchGradingSchemesFailure).toPromise();
    }

    async fetchGradingSchemeByModuleId(moduleId: string): Promise<boolean> {
        this._store.dispatch(new FetchGradingSchemeByModuleId({ moduleId }));

        return await this._actionHelper.race(FetchGradingSchemeByModuleIdSuccess, FetchGradingSchemeByModuleIdFailure).toPromise();
    }

    async deleteGradingScheme(moduleId: string): Promise<boolean> {
        this._store.dispatch(new UnsetGradingSchemeFromModule({ moduleId }));

        return await this._actionHelper.race(UnsetGradingSchemeFromModuleSuccess, UnsetGradingSchemeFromModuleFailure).toPromise();
    }

    async createGradingScheme(moduleId: string, gradingScheme: GradingScheme): Promise<boolean> {
        this._store.dispatch(new SetGradingSchemeToModule({ moduleId, gradingScheme }));

        return await this._actionHelper.race(SetGradingSchemeToModuleSuccess, SetGradingSchemeToModuleFailure).toPromise();
    }
}
